<template>
    <personalResources />
</template>
  
<script>
// import publicResources from "./publicResources.vue";
import personalResources from "./personalResources.vue"
export default {
  components: {
    personalResources
  },
  data() {
    return {
    }
  },
  created() {
    
  },
  methods: {
    
  }
}
</script>

<style scoped>

</style>

<style >
</style>